import { MATCHES_REGISTRY } from '../data/matches';
import { Match } from '../types/matches';

export const getMatchesForLeague = (sport: string, league: string): Match[] => {
  const config = MATCHES_REGISTRY.find(c => c.sport === sport && c.league === league);
  return config?.matches || [];
};
